import {
  BUTTON,
  CardDefinition,
  CAROUSEL,
  CarouselDefinition,
  HORIZONTAL_AUDIO_PLAYER,
  IMAGE,
  ImageDefinition,
  ItemIds,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT,
  VIDEO,
  VideoDefinition
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { ItemDefinition } from '../items/Item';
import { isIOS, isMobile, isSafari } from 'react-device-detect';
import { getEditorState } from '~/shell/Store';

export const Interactive7: Translator = sequence => {
  const editorMode = getEditorState().editorMode;

  const cards: CardDefinition[] = [];
  const root = translate(sequence, item => {
    if (item.__typename === 'Card') {
      const itemsForCard: ItemDefinition<ItemIds>[] = [];
      const mediaItems: ItemDefinition<ItemIds>[] = [];

      if (item.videos && item.videos.length) {
        mediaItems.push({
          id: `video_${item.id}`,
          type: VIDEO,
          values: {
            videoId: item?.videos?.[0]?.id,
            isolated: true,
            mediaUrl:
              isIOS || isSafari
                ? ([
                    item.videos[0].mediaUrl && {
                      src: item.videos[0].mediaUrl,
                      type: 'video/mp4'
                    }
                  ].filter(Boolean) as Array<{ src: string; type: string }>)
                : ([
                    item.videos[0].hlsUrl && {
                      src: item.videos[0].hlsUrl,
                      type: 'application/vnd.apple.mpegurl'
                    },
                    item.videos[0].mediaUrl && {
                      src: item.videos[0].mediaUrl,
                      type: 'video/mp4'
                    }
                  ].filter(Boolean) as Array<{ src: string; type: string }>),
            subtitlesUrl:
              item.videos && item.videos.length
                ? item.videos[0].subtitlesUrl
                : null,
            autoPlay: false,
            showProgress: false,
            showPlayButton: true,
            videoContainerStyles: {
              width: '100%',
              height: '300px',
              position: 'relative'
            }
          },
          items: []
        } as VideoDefinition);
      }

      if (item.pictures && item.pictures.length) {
        mediaItems.push({
          type: IMAGE,
          id: item.id,
          items: [],
          values: {
            url: item.pictures?.[0].mediaUrl,
            alt: item.pictures?.[0].name,
            width: '100%',
            height: '300px'
          }
        } as ImageDefinition);
      }

      if (item.audios && item.audios.length) {
        const audio = item.audios[0];

        mediaItems.push({
          type: HORIZONTAL_AUDIO_PLAYER,
          id: `${item.id}.audio`,
          items: [],
          values: {
            autoPlay: false,
            mediaUrl: audio.mediaUrl,
            name: audio.name || '',
            subtitlesUrl: audio.subtitlesUrl
          }
        });
        //i want to recheck. because on the Prod server not applied changes
      }

      if (item.body) {
        itemsForCard.push({
          id: `${item.id}_body`,
          type: TEXT,
          values: {
            value: item.body
          },
          items: []
        });
      }

      if (
        item.items &&
        item.items.length > 0 &&
        item.items[0].url &&
        item.items[0].title
      ) {
        itemsForCard.push({
          type: BUTTON,
          id: '1',
          values: {
            title: item?.items[0]?.title || 'More',
            url: item.items[0].url
          },
          items: []
        });
      }

      const itemList =
        mediaItems.length > 1
          ? [
              {
                id: `left.list`,
                type: LAYOUT_LIST,
                values: {},
                items: [...mediaItems]
              },
              ...itemsForCard
            ]
          : [...mediaItems, ...itemsForCard];

      const layoutComponent: ItemDefinition<ItemIds> = {
        type: isMobile ? LAYOUT_LIST : LAYOUT_COLUMNS,
        id: '1',
        values: {
          gridTemplateColumns:
            mediaItems.length && itemsForCard.length ? '1fr 1fr' : '1fr'
        },
        items: itemList as ItemDefinition<ItemIds>[]
      };

      cards.push(
        CardHelper(
          {
            ...item,
            title: '',
            body: '',
            videos: null,
            pictures: null
          } as ItemOfType<'Card'>,
          {
            width: editorMode ? '100%' : '80vw',
            height: 'auto',
            padding: '0px',
            extraItems: [
              {
                id: `${item.id}_title`,
                type: TEXT,
                values: {
                  value: item.title,
                  variant: 'heading1'
                },
                items: []
              },
              mediaItems.length
                ? layoutComponent
                : {
                    type: LAYOUT_COLUMNS,
                    id: '1',
                    values: {
                      gridTemplateColumns: '1fr'
                    },
                    items: itemsForCard
                  }
            ]
          }
        )
      );
    }

    return null;
  });

  root.items.push({
    type: CAROUSEL,
    id: `${sequence.id}.carousel`,
    values: {
      variant: 'vertical'
    },
    items: cards
  } as CarouselDefinition);

  return root;
};
